/* ═══════════════════════════════════════════════════════════
   DARF — Utils: shared helpers, money formatter, toast
   Loaded first — exposes window.DarfUtils and window.DarfToast
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── DOM helpers ──────────────────────────────────────────── */
  function $(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function createElement(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      Object.entries(attrs).forEach(([k, v]) => {
        if (k === 'class') node.className = v;
        else if (k === 'data') Object.entries(v).forEach(([dk, dv]) => (node.dataset[dk] = dv));
        // text und attrs waren nie vorgesehen und landeten als HTML-Attribut:
        // aus { text: 'Wirklich entfernen?' } wurde text="Wirklich entfernen?"
        // auf einem leeren Element. Genau so stand der Bestaetigungsdialog im
        // Warenkorb ohne Frage und mit zwei unbeschrifteten Knoepfen da.
        else if (k === 'text') node.textContent = v;
        else if (k === 'attrs' && v && typeof v === 'object') {
          Object.entries(v).forEach(([ak, av]) => node.setAttribute(ak, av));
        }
        else node.setAttribute(k, v);
      });
    }
    (children || []).forEach(c => {
      if (!c) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  /* ── Money formatter ──────────────────────────────────────── */
  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  /* ── Toast ────────────────────────────────────────────────── */
  function showToast(msg, duration) {
    duration = duration || 3000;
    let toast = document.getElementById('darf-toast');
    if (!toast) {
      toast = createElement('div', { class: 'toast' });
      toast.id = 'darf-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, duration);
  }

  /* ── Inline confirm dialog (replaces native confirm()) ───── */
  function darfConfirm(opts) {
    return new Promise(function(resolve){
      var o = typeof opts === 'string' ? { message: opts } : (opts || {});
      var msg     = o.message || 'Sind Sie sicher?';
      var okText  = o.confirmLabel || 'Ja, bestätigen';
      var cancel  = o.cancelLabel  || 'Abbrechen';
      var danger  = o.danger !== false;

      var overlay = createElement('div', { class: 'darf-confirm-overlay' });
      var modal   = createElement('div', { class: 'darf-confirm', attrs: { role: 'alertdialog', 'aria-modal': 'true' } });
      var msgEl   = createElement('p', { class: 'darf-confirm__msg', text: msg });
      var btnRow  = createElement('div', { class: 'darf-confirm__actions' });
      var cancelB = createElement('button', { class: 'darf-confirm__btn darf-confirm__btn--cancel', attrs: { type: 'button' }, text: cancel });
      var okB     = createElement('button', { class: 'darf-confirm__btn darf-confirm__btn--' + (danger ? 'danger' : 'primary'), attrs: { type: 'button' }, text: okText });
      btnRow.appendChild(cancelB); btnRow.appendChild(okB);
      modal.appendChild(msgEl); modal.appendChild(btnRow);
      document.body.appendChild(overlay);
      document.body.appendChild(modal);
      requestAnimationFrame(function(){ overlay.classList.add('is-open'); modal.classList.add('is-open'); });
      var prevFocus = document.activeElement;
      setTimeout(function(){ try { okB.focus(); } catch(_){} }, 50);

      function cleanup(result){
        modal.classList.remove('is-open');
        overlay.classList.remove('is-open');
        setTimeout(function(){
          if (modal.parentNode) modal.parentNode.removeChild(modal);
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          if (prevFocus && prevFocus.focus) try { prevFocus.focus(); } catch(_){}
        }, 220);
        document.removeEventListener('keydown', onKey);
        resolve(result);
      }
      function onKey(e){
        if (e.key === 'Escape') cleanup(false);
        if (e.key === 'Enter')  cleanup(true);
      }
      cancelB.addEventListener('click', function(){ cleanup(false); });
      okB.addEventListener('click', function(){ cleanup(true); });
      overlay.addEventListener('click', function(){ cleanup(false); });
      document.addEventListener('keydown', onKey);
    });
  }

  /* ── Expose globals ───────────────────────────────────────── */
  window.DarfUtils   = { $: $, $$: $$, on: on, el: createElement, money: money };
  window.DarfToast   = showToast;
  window.DarfConfirm = darfConfirm;
})();
